<template>
    <div 
        class="wg-grid" 
        :class="{
            ['wg-shadow__' + finalBoxShadow]: finalBoxShadow,
            ['wg-' + layoutPosition]: layoutPosition,
            ['wg-bg-color__' + finalBackgroundColor]: finalBackgroundColor,
            ['wg-border__' + borderLine]: borderLine,
            ['wg-border__box']: borderBox,
            ['wg-border__radius-' + originBorderRadius]: originBorderRadius,
            [className]: className,
        }"
        :style="Object.assign(extraStyle, {
            margin: finalMargin,
            padding: finalPadding,
            borderRadius: borderRadius,
            backgroundColor: customBackgroundColor,
            width: realWidth,
            height: realHeight
        })"
        >
        <slot>
        </slot>
    </div>
</template>
<script>
import Mixin from '../mixin.js';

export default {
    name: 'Grid',
    mixins: [Mixin],
    data () {
        return {
            defaultStyle: {
                spacing: 0,
                width: '',
                height: '',
                row: 1,
                column: 1
            }
        }
    },
    props: {
        styleObject: {
            type: Object,
            default () {
                return {
                }
            }
        },
        list: Array
    },
    watch: {
        list: {
            handler () {
                this.$nextTick(() => {
                    this.calculateStyle();
                })
            },
            deep: true
        }
    },
    computed: {
        realStyle () {
            return Object.assign(this.defaultStyle, (this.styleObject || {}))
        },
        realSpacing () {
            return this.realStyle.spacing + '';
        },
        realWidth () {
            let val = this.realStyle.width
            if(val) {
                if(('' + val).indexOf('%') > -1 ) {
                    return val
                }else {
                    return (val + 'px')
                }
            }else {
                return ''
            }
        },
        realHeight () {
            let val = this.realStyle.height
            if(val) {
                if(('' + val).indexOf('%') > -1 ) {
                    return val
                }else {
                    return (val + 'px')
                }
            }else {
                return ''
            }
        }
    },
    mounted () {
        this.calculateStyle()
    },
    methods: {
        calculateStyle () {
            if(!this.$el) return;
            let panel = this.$el.getBoundingClientRect()
            let children = this.$children || [];
            let column = this.realStyle.column || 1;
            let spacing = this.realSpacing.split(' ');
            let width = '';
            if(!panel && panel.width) {
                width = `${((panel.width - (column - 1) * spacing[0]) / column).toFixed(2)}px`;
            }else {
                width = `calc((100% - ${(column - 1) * spacing[0]}px) / ${column})`;
            }

            for(let i = 0, len = children.length; i < len; i++) {
                if(column > 1 && i % column < column - 1) {
                    children[i].setSpacing && children[i].setSpacing(spacing[0] + 'px');
                }
                if(i >= column && spacing[1]) {
                    children[i].setVerticalSpacing && children[i].setVerticalSpacing(spacing[1] + 'px');
                }
                children[i].setWidth && children[i].setWidth(width);
            }
        }
    }
}
</script>
<style lang="less">
</style>